import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32977b07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "node-select" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "审批人", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "抄送人", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "条件分支", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "并行分支", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "延迟等待", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "触发器", -1))

export function render(_ctx, _cache) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_Stamp = _resolveComponent("Stamp")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_Promotion = _resolveComponent("Promotion")
  const _component_Share = _resolveComponent("Share")
  const _component_Operation = _resolveComponent("Operation")
  const _component_Timer = _resolveComponent("Timer")
  const _component_SetUp = _resolveComponent("SetUp")
  const _component_el_popover = _resolveComponent("el-popover")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_popover, {
      placement: "bottom-start",
      title: "添加流程节点",
      width: 350,
      trigger: "click"
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_el_button, {
          icon: "Plus",
          type: "primary",
          size: "default",
          circle: ""
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addApprovalNode && _ctx.addApprovalNode(...args)))
          }, [
            _createVNode(_component_el_icon, {
              size: "2.5em",
              style: {"color":"rgb(255, 148, 62)"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Stamp)
              ]),
              _: 1
            }),
            _hoisted_2
          ]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.addCcNode && _ctx.addCcNode(...args)))
          }, [
            _createVNode(_component_el_icon, {
              size: "2.5em",
              style: {"color":"rgb(50, 150, 250)"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Promotion)
              ]),
              _: 1
            }),
            _hoisted_3
          ]),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.addConditionsNode && _ctx.addConditionsNode(...args)))
          }, [
            _createVNode(_component_el_icon, {
              size: "2.5em",
              style: {"color":"rgb(21, 188, 131)"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Share)
              ]),
              _: 1
            }),
            _hoisted_4
          ]),
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.addConcurrentsNode && _ctx.addConcurrentsNode(...args)))
          }, [
            _createVNode(_component_el_icon, {
              size: "2.5em",
              style: {"color":"#718dff"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Operation)
              ]),
              _: 1
            }),
            _hoisted_5
          ]),
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.addDelayNode && _ctx.addDelayNode(...args)))
          }, [
            _createVNode(_component_el_icon, {
              size: "2.5em",
              style: {"color":"#f25643"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Timer)
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.addTriggerNode && _ctx.addTriggerNode(...args)))
          }, [
            _createVNode(_component_el_icon, {
              size: "2.5em",
              style: {"color":"#15bc83"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SetUp)
              ]),
              _: 1
            }),
            _hoisted_7
          ])
        ])
      ]),
      _: 1
    })
  ]))
}